const state = {
  currentItem: {},
  currentAssignment: {},
  orderToRemove: '',
  runningCMTimer: null,
  currentWorkOrder: {},
  timerSeconds: null
};
const getters = {
  currentCorrectiveItem: state => state.currentItem,
  getCurrentCMAssignment: state => state.currentAssignment,
  getCurrentCMWorkOrder: state => state.currentWorkOrder,
  getRemovedCMOrder: state => state.orderToRemove,
  getRunningCMTimer: state => state.runningCMTimer,
  currentlyRunningCMTimer: state => {
    if (!state.runningCMTimer) return null
    let isPaused = state.runningCMTimer?.isPaused
    return isPaused ? null : state.runningCMTimer.id
  },
  timerCMSeconds: state => state.timerSeconds,
  getCorrectiveModalInputs: (state, getters) => {
    let obj = JSON.parse(JSON.stringify(getters.getWorkOrderModalInputs))
    let editAccess = getters.getIsTenantSuperuser
      || getters.getUserPermissions.site_track?.corrective_maintenance?.all_work_orders?.edit_modal?.object?.update_bool
    obj.inputs.scheduled_timestamp.viewOnly = !editAccess
    obj.inputs.due_date_timestamp.viewOnly = !editAccess
    obj.inputs.priority = {
      type: "text",
      label: "Priority",
      capitalize: true
    }
    obj.inputs.issue_images = {
      type: "images",
      parentId: "issue_id",
      imagesLabel: { present: "Attached Issue Images" },
      viewOnly: true
    }
    obj.inputs.images = {
      type: "images",
      viewOnly: !editAccess,
      imagesLabel: { present: "Work Order Images", upload: "Attach a photo to work order" }
    }
    return obj
  },
};
const actions = {
};
const mutations = {
  setCurrentCorrectiveItem(state, object) {
    state.currentItem = object
  },
  setCurrentCMAssignment(state, [id, object]) {
    state.currentAssignment = {[id]: object}
  },
  setCMOrderToRemove(state, id) {
    state.orderToRemove = id
  },
  setRunningCMTimer(state, timer) {
    state.runningCMTimer = timer
  },
  setCMTimerSeconds(state, [seconds, id, isPaused]) {
    state.timerSeconds = { seconds: seconds, id: id, isPaused: isPaused }
  },
  setCurrentCMWorkOrder(state, object) {
    state.currentWorkOrder = object
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};